import * as Yup from 'yup';

// Definindo o esquema de validação com Yup
export const validationSchema = Yup.object().shape({
    code: Yup.string().required('Código é obrigatório'),
    description: Yup.string().required('Descrição é obrigatória'),
});